import './Publication.css'

const Publication = ({available, onClick, image, title, date, authors, venue, volume, issue, quartile, pages, reads, citation, doi, status, type, tags, affiliation, publisher}) => {
    return (
        <div className='publication-container'>
            <img className='publication-image' src={image} alt='cool publication image, too sad you cant see it!'></img>
            <div className='publication-text-content'>
                <div>
                    <div className='publication-title-date-container'>
                        <span className='publication-title'>{title}</span>
                        <span className='publication-date'>{date}</span>
                    </div>
                    <span className='publication-authors'><span className='publication-label'>Authors:</span> {authors.join(", ")}</span><br/>
                    <span className='publication-venue'><span className='publication-label'>Venue:</span> {venue}</span><br/>
                    <span className='publication-venue'><span className='publication-label'>DOI:</span> {doi}</span><br/>
                    <span className='publication-venue'><span className='publication-label'>Affiliation:</span> {affiliation}</span><br/>
                    <span className='publication-volume-issue-pages'>
                        <span className='publication-label'>Vol: </span>{volume}&nbsp;
                        <span className='publication-label'>Issue: </span>{issue}&nbsp;
                        <span className='publication-label'>Pages: </span>{pages}&nbsp;
                        <span className='publication-label'>Quart: </span>{quartile}&nbsp;
                        <span className='publication-label'>Reads: </span>{reads}&nbsp;
                        {/* <span className='publication-label'>Citation: </span>{citation}&nbsp; */}
                    </span>
                </div>
                <span className='publication-link' onClick={onClick}>Read Publication</span>
            </div>
        </div>
    )
}

export default Publication
